import type { AgentRow, UserSort } from '../types/voip';
import type { FloorRow } from './floor';

const desc = (pick: (r: AgentRow) => number) => (a: AgentRow, b: AgentRow) =>
  pick(b) - pick(a) || a.agent.name.localeCompare(b.agent.name);

export function compareRows(sort: UserSort, floorById?: Map<string, FloorRow>): (a: AgentRow, b: AgentRow) => number {
  switch (sort) {
    case 'score':
      return desc((r) => floorById?.get(r.agent.id)?.score ?? 0);
    case 'focus':
      return desc((r) => floorById?.get(r.agent.id)?.focus ?? 0);
    case 'answerRate':
      return desc((r) => r.stats.answerRate);
    case 'made':
      return desc((r) => r.stats.outbound);
    case 'answered':
      return desc((r) => r.stats.inbound);
    case 'missed':
      return desc((r) => r.stats.missed);
    case 'avg':
      return desc((r) => r.stats.avgSeconds);
    case 'name':
      return (a, b) => a.agent.name.localeCompare(b.agent.name);
    default:
      return desc((r) => r.stats.talkSeconds);
  }
}
